// extracted by mini-css-extract-plugin
export default {"IonTextarea":"InputArea_IonTextarea__-X20Y","IonTextarea_active":"InputArea_IonTextarea_active__ENZ2q"};